const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/

export default {
  stringIsNotNullOrWhitespace (input) {
    return !this.stringIsNullOrWhitespace(input)
  },
  stringIsNullOrWhitespace (input) {
    return !input || typeof input !== 'string' || input.trim().length < 1
  },
  numberIsNotNull (input) {
    return !!input && !isNaN(input)
  },
  numberIsGreaterThanZero (input) {
    return parseFloat(input) > 0
  },
  numberIsNotNegative (input) {
    return parseFloat(input) >= 0
  },
  stringIsEmail (input) {
    return emailRegex.test(input)
  },
}
